import {
  JsonFormat,
  nullableJsonFormat,
  numberJsonFormat,
  objectJsonFormat,
  stringEnumJsonFormat,
  stringJsonFormat,
} from "@redotech/json/format";
import { DateSubconditionType } from "./date-subcondition-enums";

export interface DateSubcondition {
  type: DateSubconditionType;

  // For specific date types
  beforeDate?: string | null; // ISO string for ON_OR_BEFORE
  afterDate?: string | null; // ISO string for ON_OR_AFTER
  startDate?: string | null; // ISO string for BETWEEN (start)
  endDate?: string | null; // ISO string for BETWEEN (end)
  days?: number | null; // Number for LAST_N_DAYS
}

// JSON Format for serialization/deserialization
export const dateSubconditionJsonFormat: JsonFormat<DateSubcondition> =
  objectJsonFormat(
    { type: stringEnumJsonFormat(DateSubconditionType) },
    {
      beforeDate: nullableJsonFormat(stringJsonFormat),
      afterDate: nullableJsonFormat(stringJsonFormat),
      startDate: nullableJsonFormat(stringJsonFormat),
      endDate: nullableJsonFormat(stringJsonFormat),
      days: nullableJsonFormat(numberJsonFormat),
    },
  );
